module.exports = __webpack_public_path__ + "static/media/bodykjcx.68a25e6a.png";